var map = {
	"./budgens/en.json": [
		"a320",
		"chunk-2d207ea6"
	],
	"./centralcoop/en.json": [
		"d6af",
		"chunk-2d21eced"
	],
	"./nisa/en.json": [
		"738a",
		"chunk-2d0d67fb"
	],
	"./spar/en.json": [
		"5d4b",
		"chunk-2d0d36b3"
	],
	"./ubacart/en.json": [
		"1c01",
		"chunk-2d0b60c9"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a1e0";
module.exports = webpackAsyncContext;